import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/tools/user';
import { getUserInfo } from '@/request/api';
import { cloneDeep } from 'lodash';

var staticRoutes  = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login.vue'),
  },
  {
    path: '/tip',
    name: 'tip',
    component: () => import('@/pages/tip.vue'),
  },
]
var asyncRoutes = [
  {
    path: '/',
    name: '/',
    component: () => import('@/components/layout.vue'),
    redirect: '/park/parkList',
    children: [
      {
        path: 'park',
        name: 'park',
        redirect: '/park/parkList',
        role: [1, 2],
        meta: {
          title: '公园管理',
          icon: 'park',
        },
        component: () => import('@/components/index.vue'),
        children: [
          {
            path: 'parkList',
            name: 'parkList',
            component: () => import('@/pages/parkList.vue'),
            meta: {
              title: '公园管理',
              keepAlive: true,
            },
          },
          {
            path: 'parkEdit',
            name: 'parkEdit',
            component: () => import('@/pages/parkEdit.vue'),
            meta: {
              title: '基本信息',
            },
          },
          {
            path: 'newsList',
            name: 'newsList',
            component: () => import('@/pages/newsList.vue'),
            meta: {
              title: '新闻列表',
              keepAlive: true,
            },
          },
          {
            path: 'newsEdit',
            name: 'newsEdit',
            component: () => import('@/pages/newsEdit.vue'),
            meta: {
              title: '新闻详情',
            },
          },
          {
            path: 'bannerList',
            name: 'bannerList',
            component: () => import('@/pages/bannerList.vue'),
            meta: {
              title: '轮播图列表',
            },
          },
        ]
      },
      {
        path: 'hotel',
        name: 'hotel',
        redirect: '/hotel/hotelList',
        role: [1],
        meta: {
          title: '酒店管理',
          icon: 'hotel',
        },
        component: () => import('@/components/index.vue'),
        children: [
          {
            path: 'hotelList',
            name: 'hotelList',
            component: () => import('@/pages/hotelList.vue'),
            meta: {
              title: '酒店管理',
            },
          },
        ]
      },
      {
        path: 'newsType',
        name: 'newsType',
        redirect: '/newsType/newsTypeList',
        role: [1],
        meta: {
          title: '新闻类型',
          icon: 'newsType',
        },
        component: () => import('@/components/index.vue'),
        children: [
          {
            path: 'newsTypeList',
            name: 'newsTypeList',
            component: () => import('@/pages/newsTypeList.vue'),
            meta: {
              title: '新闻类型',
            },
          },
        ]
      },
      {
        path: 'fantawild',
        name: 'fantawild',
        redirect: '/fantawild/newsList',
        role: [1, 3],
        meta: {
          title: '华强方特',
          icon: 'fantawild',
        },
        menuLevel: 2,
        component: () => import('@/components/index.vue'),
        children: [
          {
            path: 'newsList',
            name: 'fantawild_newsList',
            component: () => import('@/pages/fantawild/newsList.vue'),
            powers: [-2],
            meta: {
              title: '新闻列表',
              keepAlive: true,
            },
          },
          {
            path: 'newsListEN',
            name: 'fantawild_newsListEN',
            component: () => import('@/pages/fantawild/newsList.vue'),
            powers: [-3],
            meta: {
              title: '新闻列表（英文）',
              keepAlive: true,
            },
          },
          {
            path: 'newsEdit',
            name: 'fantawild_newsEdit',
            component: () => import('@/pages/fantawild/newsEdit.vue'),
            powers: [-2],
            meta: {
              title: '新闻详情',
              hide: true,
            },
          },
          {
            path: 'newsEditEN',
            name: 'fantawild_newsEditEN',
            component: () => import('@/pages/fantawild/newsEdit.vue'),
            powers: [-3],
            meta: {
              title: '新闻详情（英文）',
              hide: true,
            },
          },
          {
            path: 'honorList',
            name: 'fantawild_honorList',
            component: () => import('@/pages/fantawild/honorList.vue'),
            powers: [-2],
            meta: {
              title: '企业荣耀',
              keepAlive: true,
            },
          },
          {
            path: 'honorListEN',
            name: 'fantawild_honorListEN',
            component: () => import('@/pages/fantawild/honorList.vue'),
            powers: [-3],
            meta: {
              title: '企业荣耀（英文）',
              keepAlive: true,
            },
          },
          {
            path: 'honorEdit',
            name: 'fantawild_honorEdit',
            component: () => import('@/pages/fantawild/honorEdit.vue'),
            powers: [-2],
            meta: {
              title: '企业荣耀详情',
              hide: true,
            },
          },
          {
            path: 'honorEditEN',
            name: 'fantawild_honorEditEN',
            component: () => import('@/pages/fantawild/honorEdit.vue'),
            powers: [-3],
            meta: {
              title: '企业荣耀详情（英文）',
              hide: true,
            },
          },
          {
            path: 'bannerList',
            name: 'fantawild_bannerList',
            component: () => import('@/pages/fantawild/bannerList.vue'),
            powers: [-2, -3],
            meta: {
              title: '轮播图列表',
            },
          },
          {
            path: 'bidList',
            name: 'fantawild_bidList',
            component: () => import('@/pages/fantawild/bidList.vue'),
            powers: [-4],
            meta: {
              title: '调研列表',
              keepAlive: true,
            },
          },
          {
            path: 'bidEdit',
            name: 'fantawild_bidEdit',
            component: () => import('@/pages/fantawild/bidEdit.vue'),
            powers: [-4],
            meta: {
              title: '调研详情',
              hide: true,
            },
          },
          {
            path: 'applyList',
            name: 'fantawild_applyList',
            component: () => import('@/pages/fantawild/applyList.vue'),
            powers: [-4],
            meta: {
              title: '申请列表',
              keepAlive: true,
            },
          },
          {
            path: 'applyEdit',
            name: 'fantawild_applyEdit',
            component: () => import('@/pages/fantawild/applyEdit.vue'),
            powers: [-4],
            meta: {
              title: '申请详情',
              hide: true,
            },
          },
        ]
      },
      {
        path: 'user',
        name: 'user',
        redirect: '/user/userList',
        role: [1],
        meta: {
          title: '用户管理',
          icon: 'user',
        },
        component: () => import('@/components/index.vue'),
        children: [
          {
            path: 'userList',
            name: 'userList',
            component: () => import('@/pages/userList.vue'),
            meta: {
              title: '用户管理',
            },
          },
        ]
      },
      // {
      //   path: 'log',
      //   name: 'log',
      //   redirect: '/log/error',
      //   role: [1],
      //   meta: {
      //     title: '错误日志',
      //     icon: 'user',
      //   },
      //   component: () => import('@/components/index.vue'),
      //   children: [
      //     {
      //       path: 'log',
      //       name: 'log',
      //       component: () => import('@/pages/log.vue'),
      //       meta: {
      //         title: '用户管理',
      //       },
      //     },
      //   ]
      // },
      // {
      //   path: 'test',
      //   name: 'test',
      //   redirect: '/test/test',
      //   meta: {
      //     title: '测试',
      //     icon: 'user',
      //     role: 1,
      //   },
      //   component: () => import('@/components/index.vue'),
      //   children: [
      //     {
      //       path: 'test',
      //       name: 'test',
      //       component: () => import('@/pages/test.vue'),
      //       meta: {
      //         title: '测试',
      //         role: 1,
      //       },
      //     },
      //   ]
      // },
      // {
      //   path: 'data',
      //   redirect: '/data/statistics',
      //   meta: {
      //     title: '数据统计',
      //     icon: 'statistics',
      //   },
      //   component: () => import('@/components/index.vue'),
      //   children: [
      //     {
      //       path: 'statistics',
      //       name: 'statistics',
      //       component: () => import('@/pages/statistics.vue'),
      //       meta: {
      //         title: '数据统计',
      //       },
      //     },
      //   ]
      // },
    ]
  },
]

var isAddRoutes = false;  // 是否加载了动态路由
const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果有保存的位置（例如，用户点击了浏览器的后退按钮），则返回到那个位置
      if (!from.meta || !from.meta.title) {  // 第三方链接跳回来需要手动滚动
        setTimeout(() => {
          window.scroll(savedPosition)
        }, 100);
      }
      return savedPosition;
    } else {
      // 否则，你可以指定默认的行为，比如回到顶部
      return { x: 0, y: 0 };
    }
  },
  routes : staticRoutes,
});
router.beforeEach(async (to, from, next) => {
  const whiteList = ['/login', '/tip'];
  if (whiteList.includes(to.path)) {
    next();
    return;
  }
  let userInfo = useUserStore().userInfo;
  if (!userInfo) {
    userInfo = await getUserInfo();
    if (userInfo.success) {
      userInfo = userInfo.data;
      useUserStore().setUser(userInfo);
    } else {
      isAddRoutes = false;
      next('/login');
      return;
    }
  }
  if (userInfo && !isAddRoutes) {
    addRoutes(userInfo);
    next({ ...to, replace: true });
    return;
  }
  window.document.title = to.meta.title ? to.meta.title + '-网站信息管理系统' : '网站信息管理系统';
  next();
});

export default router

export function removeRoutes() {
  // 清空动态路由
  isAddRoutes = false;
  const currentRoutes = router.getRoutes();
  currentRoutes.forEach(route => {
    if (!staticRoutes.find(r => r.name === route.name)) {
      router.removeRoute(route.name || route.path);
    }
  });
}
export function addRoutes(userInfo) {
  removeRoutes();
  isAddRoutes = true;
  // 根据权限生成新路由
  const accessRoutes = filterRoutesByPermission(cloneDeep(asyncRoutes), userInfo);
  try {
    accessRoutes[0].redirect = accessRoutes[0].children[0].redirect;
  } catch (error) {
  }
  if (accessRoutes.length == 0 || accessRoutes[0].children.length == 0) {
    accessRoutes[0].redirect = '/tip'
  }
  useUserStore().setMenu(JSON.parse(JSON.stringify(accessRoutes[0].children)));
  accessRoutes.forEach(route => {
    router.addRoute(route);
  });
}
function filterRoutesByPermission(routes, userInfo) {
  userInfo.accountType = userInfo.accountType * 1;
  return routes.filter(route => {
    if (route.children) {
      let filteredChildren = filterRoutesByPermission(route.children, userInfo);
      if (filteredChildren[0]) {
        route.redirect = '/' + route.path + '/' + filteredChildren[0].path;
      }
      route.children = filteredChildren;
    }
    if ((!route.role && !route.powers) || userInfo.accountType == 1) {
      return true;
    }
    let hasPower = false;
    if (route.role) {
      hasPower = route.role.includes(userInfo.accountType);
    }
    if (route.powers) {
      if (userInfo.powers.includes(-1)) {
        hasPower = true;
      } else {
        route.powers.forEach(v => {
          if (userInfo.powers.includes(v)) {
            hasPower = true;
          }
        });
      }
    }
    return hasPower;
  });
}